import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
// components
import Switch from '@mui/material/Switch'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import { FormsContainer, FormWrapper, Header, SwitchWrapper, Wrapper } from './views'
// themes
import { CloseIcon } from 'components/UI/Icons'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
// types
import { IRiskTemplate } from 'types/graphql'

interface Props {
  closePopup: () => void
  relatedForms: { riskId: string; riskTemplate: IRiskTemplate }[]
  generateDocument: (...args: any) => void
}

const ExportMenu: React.FC<Props> = ({ closePopup, relatedForms = [], generateDocument }) => {
  const router = useRouter()

  const [excludeLabels, setExcludeLabels] = React.useState(true)

  const { risk } = React.useContext(RiskAPIContext)

  const [formsToExport, setFormsToExport] = React.useState([])

  const parentForm = risk.parentRisk
    ? { riskId: risk.parentRiskId, hasParent: false, riskTemplate: risk.parentRisk.riskTemplate }
    : { riskId: risk.id, hasParent: true, riskTemplate: risk.riskTemplate }

  const forms = [parentForm, ...relatedForms]

  const onChange = (form: any) => (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setFormsToExport((prev) => (checked ? [...prev, form] : prev.filter((item) => item.riskId !== form.riskId)))
  }

  const onExportCLick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()

    if (formsToExport.length) {
      generateDocument(
        formsToExport.map((item) => ({
          riskId: item.riskId,
          hasParent: item.hasParent,
          riskTemplateId: item.riskTemplate.id
        })),
        excludeLabels
      )
    } else {
      generateDocument(
        [
          {
            riskId: router.query.id as string,
            hasParent: false,
            riskTemplateId: router.query.templateId as string
          }
        ],
        excludeLabels
      )
    }

    closePopup()
  }

  return (
    <Wrapper>
      <Header>
        <span>Export Forms</span>
        <CloseIcon right={0} onClick={closePopup} />
      </Header>

      <SwitchWrapper>
        <span>Exclude Labels</span>
        <Switch color='primary' checked={excludeLabels} onChange={(_e, checked) => setExcludeLabels(checked)} />
      </SwitchWrapper>
      {!!relatedForms.length && (
        <FormsContainer>
          {forms.map((form) => (
            <FormWrapper key={form.riskId}>
              <span>{form.riskTemplate.name}</span>
              <Switch
                color='primary'
                onChange={onChange(form)}
                checked={formsToExport.some((item) => item.riskId === form.riskId)}
              />
            </FormWrapper>
          ))}
        </FormsContainer>
      )}

      <Button
        type={'button'}
        onClick={onExportCLick}
        layout={BUTTON_LAYOUTS.PURPLE}
        disabled={relatedForms.length && !formsToExport.length}>
        Export
      </Button>
    </Wrapper>
  )
}

export default ExportMenu
